import { Navigate, Route, Routes } from 'react-router-dom';

import { InvoiceCreate } from './create';
import { InvoiceDetailPage } from './detail';

export const IndexRoute = () => {
  return (
    <Routes>
      <Route index element={<Navigate to={'/billing'} />} />
      <Route path="/create" element={<InvoiceCreate />} />
      <Route path="/:id" element={<InvoiceDetailPage />} />
    </Routes>
  );
};
